/**
 * Perché un giorno non è lavorativo, secondo il calcolo dei giorni di un'assenza (il `reason` dei
 * giorni non lavorativi della stima, `estimate-duration`). Da v1.79 il BE lo dice con precisione, e
 * la differenza conta: «riposo da turno» e «festivo» non sono la stessa cosa per chi controlla il
 * conteggio, e prima li chiamavamo entrambi «weekend».
 *
 * Sta in un file a sé, senza import, perché lo stesso vocabolario lo usa anche l'applicazione di un
 * modello di rendicontazione (`calendarReason` di `meta.summary.skippedDays[]`, decisione TS-13 del
 * 28-10-2026: il modello salta i giorni con lo stesso calcolo delle assenze). Importarlo da
 * `leaveApi` si sarebbe portato dietro mezza area assenze.
 */
export const LEAVE_NON_WORKING_REASON_LABEL: Record<string, string> = {
  weekend: 'weekend',
  holiday: 'festività',
  'patron-saint': 'patrono',
  'site-closure': 'chiusura aziendale',
  'shift-rest': 'riposo da turno',
  'rotation-rest': 'riposo da rotazione',
  'working-hour-off': 'giorno non lavorativo del tuo orario',
  'out-of-service': 'fuori dal rapporto di lavoro',
};
